import _classCallCheck from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { duplicate, hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
/**
 * A class for flatten transform nodes
 */

export var FlattenTransformNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(FlattenTransformNode, _DataFlowNode);

  function FlattenTransformNode(parent, transform) {
    var _this;

    _classCallCheck(this, FlattenTransformNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FlattenTransformNode).call(this, parent));
    _this.transform = transform;
    _this.transform = duplicate(transform); // duplicate to prevent side effects

    var _this$transform = _this.transform,
        flatten = _this$transform.flatten,
        _this$transform$as = _this$transform.as,
        as = _this$transform$as === void 0 ? [] : _this$transform$as;
    _this.transform.as = flatten.map(function (f, i) {
      return as[i] || f;
    });
    return _this;
  }

  _createClass(FlattenTransformNode, [{
    key: "clone",
    value: function clone() {
      return new FlattenTransformNode(this.parent, duplicate(this.transform));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this.transform.as);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "FlattenTransform ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var _this$transform2 = this.transform,
          fields = _this$transform2.flatten,
          as = _this$transform2.as;
      var result = {
        type: 'flatten',
        fields: fields,
        as: as
      };
      return result;
    }
  }]);

  return FlattenTransformNode;
}(DataFlowNode);